import { Field } from "formik";
import get from "lodash/get";
import { useState } from "react";
import deleteIcon from "../../assets/icons/delete-bin.svg";

export const MultiImageVideoView = ({ label, value = [] }) => {
    return (
        <div className="my-4">
            <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize w-full">
                {label}
            </h1>
            <div className="flex flex-wrap gap-5 items-center">
                {value &&
                    value
                        ?.sort((a, b) => a.index - b.index)
                        ?.map((item, index) => (
                            <div
                                key={index}
                                className="flex relative w-[10rem] h-[10rem] my-1 rounded-lg overflow-hidden "
                            >
                                {item.type == "image" ? (
                                    <img
                                        src={item.url}
                                        className="w-full h-full rounded-lg"
                                        alt={`${item.alt ?? item.url}`}
                                    />
                                ) : (
                                    <video
                                        controls
                                        className="w-full h-full object-cover"
                                    >
                                        <source
                                            src={item.url}
                                            type="video/mp4"
                                        />
                                        Your browser does not support the video
                                        tag.
                                    </video>
                                )}

                                <label
                                    className="absolute top-2 left-2 z-10 bg-white/90 rounded-md p-0.5 flex items-center justify-center shadow-sm"
                                    aria-label={`Select media-${index}`}
                                >
                                    <input
                                        type="checkbox"
                                        checked={item.checked}
                                        className="w-4 h-4 md:w-5 md:h-5 accent-indigo-600"
                                    />
                                </label>
                            </div>
                        ))}
            </div>
        </div>
    );
};
